export const LMS_MODULES_RESET_STATE = 'LMS_MODULES_RESET_STATE';
export const LMS_MODULES_CURRENT_ITEM = 'LMS_MODULES_CURRENT_ITEM';

export const LMS_MODULES_REQUEST_LOADING = 'LMS_MODULES_REQUEST_LOADING';
export const LMS_MODULES_REQUEST_SUCCESS = 'LMS_MODULES_REQUEST_SUCCESS';
export const LMS_MODULES_REQUEST_FAILED = 'LMS_MODULES_REQUEST_FAILED';

export const LMS_MODULES_CURRENT_ACTION = 'LMS_MODULES_CURRENT_ACTION';
export const LMS_MODULES_RESET_ACTION = 'LMS_MODULES_RESET_ACTION';
